import React from 'react';
import { Form, reduxForm } from 'redux-form';
import { HashLoader } from 'react-spinners';

import AppModal from '../../../modal/appModal';
import { FormId } from '../../../../constants/formId';
import { SimpleModalId } from '../../../../constants/modalId';
import { AppFileField } from '../../../form/appFileField';
import { AppSelectField } from '../../../form/appSelectField';
import { required, requiredString } from '../../../form/formValidations';
import {
  EditChapterFormDataProps,
  EditChapterFormOwnProps,
  EditChapterFormOnSubmitProps,
  ChapterFormFieldsProps,
} from '../chapter.types';
import { allowedImageExtensions, allowedVideoExtensions, validateVideoOrImageFile } from '../../utils/fileValidators';
import styles from '../../ClipGeneratorPage.module.scss';

import { chapterTypeOptions } from './createChapterFormContainer';

const ChapterFormFields = ({ orderIndexOptions }: ChapterFormFieldsProps) => (
  <>
    <AppSelectField name="orderIndex" label="Order Index" options={orderIndexOptions} validate={[required]} />
    <AppSelectField
      name="chapterType"
      key="chapterType"
      label="Chapter Type"
      options={chapterTypeOptions}
      validate={[required, requiredString]}
    />
    <AppFileField
      name="asset"
      label="Asset"
      extensions={allowedImageExtensions.concat(allowedVideoExtensions)}
      validate={validateVideoOrImageFile}
    />
  </>
);

const EditChapterForm = ({ form, handleSubmit, orderIndexOptions, isLoading, onSubmit }: EditChapterFormOwnProps) => {
  const handleOnSubmit = (values: EditChapterFormDataProps) => onSubmit(values);

  return (
    <AppModal
      form={form}
      title="Edit Chapter"
      id={SimpleModalId.EditAfterEffectsChapterModal}
      hideOpenButton
      hideActionButtons={isLoading}
      className={styles.modal}
    >
      {isLoading ? (
        <div className={styles.loader}>
          <HashLoader />
        </div>
      ) : (
        <Form id={form} onSubmit={handleSubmit(handleOnSubmit)}>
          <ChapterFormFields orderIndexOptions={orderIndexOptions} />
        </Form>
      )}
    </AppModal>
  );
};

export const EditChapterFormContainer = reduxForm<EditChapterFormDataProps, EditChapterFormOnSubmitProps>({
  form: FormId.EditAfterEffectsChapterForm,
  enableReinitialize: true,
})(EditChapterForm);
